<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-datetime v-model="isoDate"
                    :clearable="clearable"
                    :float-label="label | capitalize"
                    :type="type"
                    :format="computedFormat"
                    :format24h="computedFormat24h"
                    :format-model="formatModel"
                    :min="min"
                    :max="max"
                    :color="color"
                    ref="field"
                    :disable="form.busy || disable"
                    @input="formatInput"></q-datetime>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QDatetime} from 'quasar-framework'
    import moment from 'moment'

    export default {
        name: 'VDatetime',

        mixins,

        props: {
            format: {
                type: String,
                default() {
                    return this.$t('date_format')
                }
            },
            format24h: {
                type: Boolean,
                default() {
                    return this.$t('datetime_24h') === 'true'
                }
            },
            formatModel: {
                type: String,
                default: 'auto'
            },
            formatData: {
                type: String,
                default: 'DD/MM/YYYY'
            },
            min: String,
            max: String,
            type: {
                type: String,
                default: 'date'
            }
        },

        watch: {
            value(newValue) {
                this.inputValue = newValue
                this.makeISO()
                if (!newValue) {
                    this.$refs.field.clear()
                }
            }
        },

        components: {
            QDatetime
        },

        computed: {
            computedFormat() {
                if (!this.$options.propsData.format && this.type == 'datetime')
                    return this.$t('datetime_format')

                if (!this.$options.propsData.format && this.type == 'time')
                    return this.$t('HH:mm')

                return this.format
            },

            computedFormat24h() {
                if (!this.$options.propsData.format24h && this.type == 'datetime')
                    return this.$t('datetime_24h') === 'true'
                return this.format24h
            },

            computedFormatData() {
                if (!this.$options.propsData.formatData && this.type == 'datetime')
                    return 'DD/MM/YYYY HH:mm'

                if (this.type == 'time')
                    return this.$t('HH:mm')

                return this.formatData
            }
        },

        data() {
            return {
                isoDate: null
            }
        },

        mounted() {
            this.makeISO()
        },

        methods: {
            formatInput() {
                this.inputValue = date.formatDate(this.isoDate, this.computedFormatData)
                this.onInput()
            },

            makeISO() {
                if (this.inputValue)
                    this.isoDate = moment(this.inputValue, this.computedFormatData).format('YYYY-MM-DD\THH:mm:ss.SSSZ')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VDatetime.vue